export default __webpack_public_path__ + "static/media/jj_logos_overlapping.bec60baf.png";